/* Awards shown as badges on the site (hero photo, footer, enrol page).

   `from` is the first UK date an award may appear. Teach Primary results are
   embargoed until it, so the badge stays out of the page until the daily
   build on or after that date (00:07 UTC). `?awards=preview` shows every
   award in the browser early, for checking the layout before the embargo
   lifts; it never reaches the prerendered HTML.

   Newest first. Add the earlier Teach Secondary results here once we have
   their logo files. */
export const AWARDS = [
  {
    id: "teach-primary-2026",
    from: "2026-11-09",
    src: "/images/awards/teach-primary-2026-winner",
    width: 480,
    height: 420,
    alt: "Teach Primary Awards 2026 winner",
    label: "Winner, Teach Primary Awards 2026",
    detail: "Free British Sign Language Resources",
  },
];

const ukToday = () =>
  new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/London" }).format(new Date());

export function visibleAwards({ preview = false, today = ukToday() } = {}) {
  return preview ? AWARDS : AWARDS.filter((a) => today >= a.from);
}
